import { render, staticRenderFns } from "./ManualsGrid.vue?vue&type=template&id=61944820"
import script from "./ManualsGrid.vue?vue&type=script&lang=js"
export * from "./ManualsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports